import { ITermCourse } from '../../../../interfaces/scheduler_interfaces';
import { TermScheduleFlags } from '../../../../views/course_scheduler/services/term_schedule_flags';
import { UnscheduledSectionServant } from '../../../../views/unscheduled_sections/servants/unscheduled_section_servant';

import * as _4 from 'lodash4';
import { PreferencesSelectionModel } from '../../../../views/term_courses/models/preferences_selection_model';

class CRNCourseTileController {
  private course: ITermCourse;
  constructor(
    private $state: ng.ui.IStateService,
    private ngTermScheduleFlags: TermScheduleFlags,
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private ngPreferencesSelectionModel: PreferencesSelectionModel
  ) {}
  isCoreqEnforcementEnabled() {
    return this.ngTermScheduleFlags.isCoreqEnforcementEnabled();
  }
}

class CRNCourseTileComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      course: '<'
    };
    this.controller = CRNCourseTileController;
    this.templateUrl =
      'capability-ng-scheduler/src/components/crn_search/components/crn_course_tile/crn_course_tile.html';
  }
}
angular.module('capability-ng-scheduler').component('crnCourseTile', new CRNCourseTileComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/crn_search/components/crn_course_tile/crn_course_tile.ts